<template>
	<div>
		<div class="searchBox">
			<span>清单选择</span>
			<el-select class='select' v-model="value" filterable placeholder="请选择" clearable>
				<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
				</el-option>
			</el-select>
			<el-button type="primary" @click='addFun'>添加</el-button>
		</div>
		<div class="table">
			<el-table :data="tableData" style="width: 100%" height='calc(100vh - 280px)'>
				<el-table-column prop="prodectName" label="清单名称">
				</el-table-column>
				<el-table-column label="张数">
					<template slot-scope='scope'>
						<el-input-number v-model="scope.row.num" @change="handleChange(scope.$index,scope.row.num)" :min="1"  label="描述文字"></el-input-number>
					</template>
				</el-table-column>
				<el-table-column label="金额">
					<template slot-scope='scope'>
						<span class="yellow">{{scope.row.money}}元</span>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope='scope'>
						<el-button @click.native.prevent="deleteRow(scope.$index, tableData)" type="text" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<p class="p">共计 {{zhang}} 张：<span class="yellow">￥{{moneyAll/100}}元</span></p>
		<el-button class='btn' type="primary" @click='submitFun()'>确认</el-button>
	</div>
</template>

<script>
	import { productList,entityOrder } from '@/axios/api.js'
	export default {
		data() {
			return {
				options: [],
				tableData: [],
				value: '',
				dataItem:{},
				dataObject:{},
				zhang:0,
				moneyAll:0
			}
		},
		methods: {
			getProdect() {
				productList({orderType:2})
				.then( res => {
				    console.log(res);
						this.options=res.data.obj
				})
				.catch(err => {
				    console.log(err);
				})
			},
			addFun(){
				if(this.value == '') return this.$message.warning('请先选择清单！');
				var bTn=true;
				this.dataItem=this.options.find(item => {
					return item.id === this.value
				})
				this.dataObject ={
					prodectId:this.dataItem.id,
					prodectName:this.dataItem.name,
					num:1,
					price:this.dataItem.suggestPrice,
					money:this.dataItem.suggestPrice/100
				}
				this.tableData.forEach((item,index) => {
					if(item.prodectId == this.dataObject.prodectId){
						item.num++;
						item.money=item.price *item.num/100;
						bTn=false;
					}
				})
				if(bTn){
					this.tableData.push(this.dataObject);
				}
				this.sumFun(this.tableData)
			},
			handleChange(index,value) {
				this.tableData[index].money=value*this.tableData[index].price/100;
				this.sumFun(this.tableData)
			},
			sumFun(data){
				this.zhang=0;
				this.moneyAll=0;
				data.forEach(item => {
					this.zhang+=item.num;
					item.moneyAll=item.price*item.num;
					this.moneyAll+=item.moneyAll
				})
			},
			submitFun(){
				if(this.tableData.length == 0) return this.$message.warning('请先选择购买清单！')
				this.$router.push({
					name:'address',
					params:{data:this.tableData,allMoney:this.moneyAll,num:this.zhang}
				})
			},
			deleteRow(index, rows) {
				rows.splice(index, 1);
			}
		},
		mounted(){
			this.getProdect()
		},
		watch:{
			'tableData'(){
				this.sumFun(this.tableData)
			}
		}
	}
</script>

<style scoped>
	.searchBox {
		margin: 20px 0;
	}

	.select {
		width: 300px;
		margin-right: 20px;
	}
	.btn{display: block;width: 200px;margin: 0 auto;}
	.p{text-align: right;margin-top: 10px;}
</style>



// WEBPACK FOOTER //
// src/views/card/index.vue